import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
  colorBlack300,
  colorBlack900,
  colorGrey400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryLaptopMin,
} from '@/styleUtils';

export const Wrapper = styled.header`
  display: flex;
  flex-direction: column;
  margin: -16px -16px 0;
  padding: 16px 16px 0;
  background-color: ${colorWhite};
  gap: 24px;
`;

export const MainInfo = styled.header`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.h1`
  font: 700 18px/24px ${fontFamilySecondary};
  color: ${colorBlack900};
  text-align: center;

  @media ${mediaQueryLaptopMin} {
    font: 700 30px/40px ${fontFamilySecondary};
  }
`;

export const Description = styled.p`
  font: 400 13px/16px ${fontFamilyPrimary};
  color: ${colorGrey400};
  letter-spacing: 0.13px;
  text-align: center;
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 16px;
  width: 100%;

  @media ${mediaQueryLaptopMin} {
    padding: 10px 16px;
  }
`;

export const MenuItemLink = styled(Link)`
  font: 500 13px/20px ${fontFamilyPrimary};
  color: ${colorBlack300};
  letter-spacing: 0.26px;
  text-transform: uppercase;
  outline: 0;
  border: none;
  display: flex;
  align-items: center;
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
  }
`;
